var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decoration",class:{'clear-header':_vm.isWechatBrowser}},[(!_vm.isWechatBrowser)?_c('my-header',{attrs:{"title":"工地直播","showBack":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }